import { cn } from '@/lib/utils'
import {
  FileEdit,
  Send,
  Clock,
  CheckCircle,
  AlertTriangle,
  XCircle,
} from 'lucide-react'
import type { InvoiceStatus } from '@/types/invoice'

const statusConfig: Record<InvoiceStatus, {
  label: string
  bgColor: string
  textColor: string
  icon: React.ComponentType<{ className?: string }>
}> = {
  draft: {
    label: 'Brouillon',
    bgColor: 'bg-gray-100',
    textColor: 'text-gray-700',
    icon: FileEdit,
  },
  sent: {
    label: 'Envoyee',
    bgColor: 'bg-blue-100',
    textColor: 'text-blue-700',
    icon: Send,
  },
  en_attente: {
    label: 'En attente',
    bgColor: 'bg-gold-100',
    textColor: 'text-gold-700',
    icon: Clock,
  },
  payee: {
    label: 'Payee',
    bgColor: 'bg-mint-100',
    textColor: 'text-mint-700',
    icon: CheckCircle,
  },
  overdue: {
    label: 'En retard',
    bgColor: 'bg-red-100',
    textColor: 'text-red-700',
    icon: AlertTriangle,
  },
  cancelled: {
    label: 'Annulee',
    bgColor: 'bg-brown-100',
    textColor: 'text-brown-700',
    icon: XCircle,
  },
}

export interface InvoiceStatusBadgeProps {
  statut: InvoiceStatus
  showIcon?: boolean
  size?: 'sm' | 'md'
  className?: string
}

export function InvoiceStatusBadge({
  statut,
  showIcon = true,
  size = 'sm',
  className,
}: InvoiceStatusBadgeProps) {
  const config = statusConfig[statut] || statusConfig.draft
  const Icon = config.icon

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
  }

  return (
    <span
      className={cn(
        'inline-flex items-center font-medium rounded-full',
        config.bgColor,
        config.textColor,
        sizeClasses[size],
        className
      )}
    >
      {showIcon && <Icon className={cn('mr-1', size === 'sm' ? 'w-3 h-3' : 'w-4 h-4')} />}
      {config.label}
    </span>
  )
}

// Export configuration for use in other components
export { statusConfig }
